import * as React from 'react';
import { Heading as Heading$1 } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const variantMap = {
    h1: 'large',
    h2: 'medium',
    h3: 'small',
    h4: 'smallest',
    h5: 'subheading1',
    h6: 'subheading2'
};
const CmsHeading = ({ meta: { title , type , alignment  }  })=>/*#__PURE__*/ React.createElement(Heading$1, {
        className: `heading heading--${alignment}`,
        variant: variantMap[type],
        align: alignment
    }, title)
;
var Heading = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsHeading);

export { CmsHeading, Heading as default };
//# sourceMappingURL=Heading.js.map
